import React from "react";
import { Container } from "react-bootstrap";
import LayoutDefault from "../layouts/LayoutDefault";

const Home = () => {
  return (
    <Container fluid>
      <LayoutDefault />
    </Container>
  );
};

export default Home;
